import React, { useEffect, useContext, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

import {
  GetJudgeSettingItems,
  SetJudgeSettingItems,
  JudgeSettingItem,
  GetJudgeSettingParameter,
  JudgeSettingParameter,
  GetSideBandFreqItems,
  GethandleBearingFeaturesFreqItems,
  JudgeSettingItemModel,
  JudgeSettingErrorData,
  GetJudgeAutoSettingItems,
  JudgeAutoSettingItem,
  SetJusgeAutoSetting,
  IsBearingFeaturesFreqButton,
  IsSideBandFreqItemButton,
  GetJudgeSelectItemInfo,
} from './JudgeSetting';
import JudgeSettingItemRow from './JudgeSettingItemRowEx';
import { TableBaseStyle, JudgeSettingStyle } from './JudgeSettingStyle';

import { DialogAction, useModal } from '../../../../function/useModal';
import { PLCcollectSettingType } from '../CollectSetting/CollectSettingDefine';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import { ErrorCode } from '../../../../ErrorCode';
import SimpleDialog from '../../../atoms/Dialog/SimpleDialog';
import { AppContext } from '../../../../App';
import { MST_CLC_TYP, GetMstClcTyp } from '../../../../function/MstClcTypModels';
import {
  JudgeSettingSelectType,
  GetJudgeSettingSelectItems,
  GetJudgeSettingSelectConanItems,
} from '../../../../function/JudgeSettingSelectModel';
import { IsConanAirPlc } from '../../../../function/PlcNoModel';
import { NameItemKind, AlmTypKind } from '../../../../Constant';

type JudgeSettingDialogProps = {
  dialog: DialogAction<JudgeSettingDialogResponse>;
  plcCollectSetting: PLCcollectSettingType;
  plcNo: number;
  aiCard: number;
  aiCh: number;
  /**
   *速度・変位判定マスク変更通知
   */
  onChangeDspMskOn: (value: number) => void;
};

export type JudgeSettingDialogResponse = {};

const JudgeSettingDialog: React.FC<JudgeSettingDialogProps> = (props: JudgeSettingDialogProps) => {
  const { login } = useContext(AppContext);

  const { t } = useTranslation();
  const tableBaseStyle = TableBaseStyle();
  const judgeSettingStyle = JudgeSettingStyle();

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);
  const [items, setItems] = useState<JudgeSettingItem[]>([]);
  const [mclcTypeCombos, setMclcTypeCombos] = useState<ComboBoxItemType[]>([]);
  const [jdgCombos, setJdgCombos] = useState<ComboBoxItemType[]>([]);
  const [clcCombos, setClcCombos] = useState<ComboBoxItemType[]>([]);
  const [almCombos, setAlmCombos] = useState<ComboBoxItemType[]>([]);
  const [flgUpdate, setFlgUpdate] = useState<boolean>(false);
  const [flgConfirm, confirmDlg] = useModal<ConfirmDialogResponse>();
  const [msgConfirm, setMsgConfirm] = useState<string>();

  // 指定した型の値で書き替えられる。nullは不可。
  const judgeAutoSettings = useRef<JudgeAutoSettingItem[]>(null!);
  //各コンボボックスの選択候補の絞り込み条件設定
  const judgeItemSelectInfo = useRef<JudgeSettingSelectType[]>(null!);

  //APIレスポンスダイアログ
  const [messageDialogOpen, setMessageDialogOpen] = React.useState(false);
  const [showTitle, setShowTitle] = React.useState<string>('');
  const [showMessage, setShowMessage] = React.useState<string>('');

  const isBearingFeaturesFreqButton = IsBearingFeaturesFreqButton(props.plcCollectSetting);
  const isSideBandFreqItemButton = IsSideBandFreqItemButton(props.plcCollectSetting);
  const [dispMaskOn, setDispMaskOn] = React.useState<number>(props.plcCollectSetting.DispMaskOn);

  useEffect(() => {
    var judgeItems: JudgeSettingItem[] = [];
    GetJudgeSettingItems(props.plcNo, props.aiCard, props.aiCh)
      .then((resp: JudgeSettingItem[]) => {
        judgeItems = resp;
        if (IsConanAirPlc(String(props.plcNo) ?? '0')) {
          return GetJudgeSettingSelectConanItems();
        } else {
          return GetJudgeSettingSelectItems();
        }
      })
      .then((r) => {
        if (r.ResponceDataModel.ErrorCode != ErrorCode.ERR_CODE_NONE) {
          setShowTitle(t('JudgeSettingDialog.判定値設定', '判定値設定'));
          setShowMessage(
            t('JudgeSettingDialog.判定値項目自動選択設定取得失敗', '判定値項目自動選択設定取得に失敗しました。')
          );
          setMessageDialogOpen(true);
        } else {
          judgeItemSelectInfo.current = r.JudgeSettingSelectItems;
        }
        console.debug(['GetJudgeSettingSelectItems', r]);
        return GetJudgeAutoSettingItems();
      })
      .then((r) => {
        if (r.ResponceDataModel.ErrorCode != ErrorCode.ERR_CODE_NONE) {
          setShowTitle(t('JudgeSettingDialog.判定値設定', '判定値設定'));
          setShowMessage(
            t(
              'JudgeSettingDialog.判定値自動設定CSVファイル取得に失敗しました',
              '判定値自動設定CSVファイル取得に失敗しました。'
            )
          );
          setMessageDialogOpen(true);
        } else {
          judgeAutoSettings.current = r.JudgeAutoSettingList;
        }
        console.debug(['GetJudgeAutoSettingItems', r]);

        judgeItems.forEach((r) => {
          if (r.MCLC_TYP_ID === 0) {
            r.CHANGE_INVALID = 0;
          }
          //異常内容検討
        });
        setItems(judgeItems);
      })
      .catch((error) => {
        setShowTitle(t('JudgeSettingDialog.判定値設定', '判定値設定'));
        setShowMessage(
          t('JudgeSettingDialog.データ取得時にエラーが発生しました', 'データ取得時にエラーが発生しました')
        );
        console.error(error);
      })
      .finally(() => { });
  }, []);

  useEffect(() => {
    GetJudgeSettingParameter().then((prm: JudgeSettingParameter) => {
      console.debug(['--GetJudgeSettingParameter--', prm]);
      setJdgCombos(
        prm.JudgeTypes.map<ComboBoxItemType>((ci) => {
          return { index: ci.Key, name: ci.Disp };
        })
      );
      setClcCombos(
        prm.CLCTypes.map<ComboBoxItemType>((ci) => {
          return { index: ci.Key, name: ci.Disp, tag: ci.Tag };
        })
      );
      setAlmCombos(
        prm.AlarmKinds.map<ComboBoxItemType>((ci) => {
          return { index: ci.Key, name: ci.Disp, tag: ci.Tag };
        })
      );
      setMclcTypeCombos(
        prm.MClcTypes.map<ComboBoxItemType>((ci) => {
          return { index: ci.Key, name: ci.Disp, tag: ci.Tag };
        })
      );
    });
  }, []);

  /**
   * 値変更event
   * @param item
   */
  const updateItem = (item: JudgeSettingItem) => {
    const idx = items.findIndex((it) => it.JDG_NO == item.JDG_NO);
    if (idx >= 0) {
      items[idx] = item;
      console.debug(['updateItem - ', items[idx]]);
      if (flgUpdate === false) {
        setFlgUpdate(true);
      }
    }
  };

  /**
   * リストから軸受特徴周波数自動設定されている項目を探す
   * @returns
   */
  const getBearingFeaturesFreqData = (): JudgeSettingItem[] => {
    let ret: JudgeSettingItem[] = [];
    if (IsConanAirPlc(props.plcCollectSetting.PLCNo)) {
      if (props.plcCollectSetting.ItemNameNo === NameItemKind.LOADSIDE) {
        ret = items.filter(
          (row) =>
            row.JDG_TYP == 5 &&
            row.MCLC_TYP_ID >= AlmTypKind.eConanfft3dSpd1_loadside &&
            row.MCLC_TYP_ID <= AlmTypKind.eConanfft3dSpd4_loadside
        );
      } else if (props.plcCollectSetting.ItemNameNo === NameItemKind.ANTI_LOADSIDE) {
        ret = items.filter(
          (row) =>
            row.JDG_TYP == 5 &&
            row.MCLC_TYP_ID >= AlmTypKind.eConanfft3dSpd1_aloadside &&
            row.MCLC_TYP_ID <= AlmTypKind.eConanfft3dSpd4_aloadside
        );
      } else if (props.plcCollectSetting.ItemNameNo === NameItemKind.FLAME) {
        ret = items.filter(
          (row) =>
            row.JDG_TYP == 5 &&
            ((row.MCLC_TYP_ID >= AlmTypKind.eConanfft3dSpd1_loadside &&
              row.MCLC_TYP_ID <= AlmTypKind.eConanfft3dSpd4_loadside) ||
              (row.MCLC_TYP_ID >= AlmTypKind.eConanfft3dSpd1_aloadside &&
                row.MCLC_TYP_ID <= AlmTypKind.eConanfft3dSpd4_aloadside))
        );
      }
    } else {
      ret = items.filter(
        (row) =>
          row.CHANGE_INVALID === 1 &&
          row.JDG_TYP == 5 &&
          row.MCLC_TYP_ID >= AlmTypKind.eChr1 &&
          row.MCLC_TYP_ID <= AlmTypKind.eChr4
      );
    }

    return ret;
  };

  /**
   *　軸受特徴周波数自動設定
   */
  const BearingFeaturesFreqButtonAction = () => {
    //console.debug(['- flgUpdate -', flgUpdate]);

    if (getBearingFeaturesFreqData().length === 0) {
      if (IsConanAirPlc(props.plcCollectSetting.PLCNo)) {
        if (props.plcCollectSetting.ItemNameNo === NameItemKind.LOADSIDE) {
          handleBearingFeaturesFreq(NameItemKind.LOADSIDE);
        } else if (props.plcCollectSetting.ItemNameNo === NameItemKind.ANTI_LOADSIDE) {
          handleBearingFeaturesFreq(NameItemKind.ANTI_LOADSIDE);
        } else if (props.plcCollectSetting.ItemNameNo === NameItemKind.FLAME) {
          handleBearingFeaturesFreqByFrame();
        } else {
          handleBearingFeaturesFreq(NameItemKind.LOADSIDE);
        }
      } else {
        //初回追加の場合
        handleBearingFeaturesFreq(NameItemKind.LOADSIDE);
      }
    } else {
      if (flgUpdate) {
        setMsgConfirm(t('JudgeSettingDialog.設定を更新しますか?', '設定を更新しますか?'));
        confirmDlg
          .open()
          .apply((_) => {
            if (IsConanAirPlc(props.plcCollectSetting.PLCNo)) {
              if (props.plcCollectSetting.ItemNameNo === NameItemKind.LOADSIDE) {
                handleBearingFeaturesFreq(NameItemKind.LOADSIDE);
              } else if (props.plcCollectSetting.ItemNameNo === NameItemKind.ANTI_LOADSIDE) {
                handleBearingFeaturesFreq(NameItemKind.ANTI_LOADSIDE);
              } else if (props.plcCollectSetting.ItemNameNo === NameItemKind.FLAME) {
                handleBearingFeaturesFreqByFrame();
              } else {
                handleBearingFeaturesFreq(NameItemKind.LOADSIDE);
              }
            } else {
              handleBearingFeaturesFreq(NameItemKind.LOADSIDE);
            }
          })
          .cancel((_) => { });
      }
    }
  };

  /**
   * 軸受特徴周波数自動設定
   * （内輪・外輪・転動体・保持器）を自動で追加
   * @param typeid_first 追加対象の演算種別ID　開始ID
   * @param typeid_end　追加対象の演算種別ID　終了ID
   */
  const handleBearingFeaturesFreq = (itemNameNo: number) => {
    GethandleBearingFeaturesFreqItems(props.plcNo, props.aiCard, props.aiCh, itemNameNo).then(
      (resp: JudgeSettingItemModel) => {
        setBearingFeaturesFreq(resp);
      }
    );
  };
  /**
   * 軸受特徴周波数自動設定（コナンエアフレーム対応）
   * 負荷側、反負荷側の順番で呼出
   * （内輪・外輪・転動体・保持器）を自動で追加
   * @param typeid_first 追加対象の演算種別ID　開始ID
   * @param typeid_end　追加対象の演算種別ID　終了ID
   */
  const handleBearingFeaturesFreqByFrame = () => {
    GethandleBearingFeaturesFreqItems(props.plcNo, props.aiCard, props.aiCh, NameItemKind.LOADSIDE)
      .then((resp: JudgeSettingItemModel) => {
        setBearingFeaturesFreq(resp);
        return GethandleBearingFeaturesFreqItems(props.plcNo, props.aiCard, props.aiCh, NameItemKind.ANTI_LOADSIDE);
      })
      .then((resp: JudgeSettingItemModel) => {
        setBearingFeaturesFreq(resp);
      });
  };

  /**
   *軸受特徴周波数自動設定データ画面セット
   * @param resp
   * @returns
   */
  const setBearingFeaturesFreq = (resp: JudgeSettingItemModel) => {
    if (resp.ResponceData.ErrorCode == ErrorCode.ERR_CODE_NONE) {
      addBearingFeaturesFreqItem(resp.JdgSetItems);
      return undefined;
    }
    //エラー
    setShowTitle(t('JudgeSettingDialog.軸受特徴周波数自動設定', '軸受特徴周波数自動設定'));
    if (resp.ResponceData.ErrorCode == ErrorCode.ERR_CODE_JSET_NO_BEARING_FILE) {
      setShowMessage(t('JudgeSettingDialog.CSVファイルを読み込めませんでした', 'CSVファイルを読み込めませんでした'));
    } else if (resp.ResponceData.ErrorCode == ErrorCode.ERR_CODE_JSET_NO_BEARING_INFO) {
      setShowMessage(t('JudgeSettingDialog.軸受情報が未登録です', '軸受情報が未登録です'));
    } else {
      setShowMessage(t('JudgeSettingDialog.システムエラーが発生しました', 'システムエラーが発生しました'));
    }
    setMessageDialogOpen(true);
  };

  // 側帯波周波数自動設定
  const handleSideBandFreq = () => {
    console.debug(['handleSideBandFreq()', props.plcNo, props.aiCard, props.aiCh]);
    GetSideBandFreqItems(props.plcNo, props.aiCard, props.aiCh).then((resp: JudgeSettingItemModel) => {
      if (resp.ResponceData.ErrorCode == ErrorCode.ERR_CODE_NONE) {
        addSideBandFreqItem(resp.JdgSetItems);
        return;
      } else {
        //エラー
        setShowTitle(t('JudgeSettingDialog.側帯波周波数自動設定', '側帯波周波数自動設定'));
        setShowMessage(t('JudgeSettingDialog.システムエラーが発生しました', 'システムエラーが発生しました'));
        setMessageDialogOpen(true);
      }
    });
  };

  /**
   * 軸受特徴周波数自動設定 リスト追加
   * @param bearingItems
   */
  const addBearingFeaturesFreqItem = (bearingItems: JudgeSettingItem[]) => {
    const regs: Array<string> = [];
    bearingItems.forEach((bi) => {
      //console.debug(bi);
      //異常種別登録済みチェック FFT(ENV)（内輪損傷、外輪損傷、転動体損傷、保持器損傷）
      let regedIdx = items.findIndex(
        (row) => row.CHANGE_INVALID === bi.CHANGE_INVALID && row.JDG_TYP == 5 && row.MCLC_TYP_ID == bi.MCLC_TYP_ID
      );
      console.debug(`Registered idx:${regedIdx}, ${items[regedIdx]}`);
      if (regedIdx >= 0) {
        //上書き
        items[regedIdx] = { ...items[regedIdx], FREQ_C: bi.FREQ_C };
        let autoValue = SetJusgeAutoSetting(items[regedIdx], judgeAutoSettings.current, props.plcCollectSetting);
        if (autoValue.ALM_LIM !== null && autoValue.WRN_LIM !== null) {
          items[regedIdx].ALM_LIM = autoValue.ALM_LIM;
          items[regedIdx].WRN_LIM = autoValue.WRN_LIM;
        }
        setFlgUpdate(true);

        return;
      }

      //演算種別タイプが未使用(0)の行をアップデートする
      const idx = items.findIndex((it) => it.MCLC_TYP_ID == 0);
      console.debug(`find idx:${idx}`);
      if (idx >= 0) {
        bi.JDG_NO = items[idx].JDG_NO;
        items[idx] = bi;
        let autoValue = SetJusgeAutoSetting(items[idx], judgeAutoSettings.current, props.plcCollectSetting);
        if (autoValue.ALM_LIM !== null && autoValue.WRN_LIM !== null) {
          items[idx].ALM_LIM = autoValue.ALM_LIM;
          items[idx].WRN_LIM = autoValue.WRN_LIM;
        }
        setFlgUpdate(true);
      }
    });
    setItems([...items]);
  };

  /**
   * 側帯波周波数自動設定 リスト追加
   * @param freqItems
   */
  const addSideBandFreqItem = (freqItems: JudgeSettingItem[]) => {
    const regs: Array<string> = [];

    freqItems.forEach((fi) => {
      //console.debug(fi);
      //異常種別登録済みチェック FFT（側帯波周波数(－側)、電流側帯波周波数(＋側)）
      let regedIdx = items.findIndex(
        (row) =>
          row.CHANGE_INVALID === 1 &&
          row.JDG_TYP == 4 &&
          (row.MCLC_TYP_ID == 9 || row.MCLC_TYP_ID == 10) &&
          row.MCLC_TYP_ID == fi.MCLC_TYP_ID
      );
      if (regedIdx >= 0) {
        //上書き
        items[regedIdx] = { ...items[regedIdx], FREQ_C: fi.FREQ_C };
        let autoValue = SetJusgeAutoSetting(items[regedIdx], judgeAutoSettings.current, props.plcCollectSetting);
        if (autoValue.ALM_LIM !== null && autoValue.WRN_LIM !== null) {
          items[regedIdx].ALM_LIM = autoValue.ALM_LIM;
          items[regedIdx].WRN_LIM = autoValue.WRN_LIM;
        }
        console.debug(['異常種別登録済みのデータを上書き更新']);
        setFlgUpdate(true);
        return;
      }

      //診断タイプが未使用(0)の行をアップデートする
      const idx = items.findIndex((it) => it.JDG_TYP == 0);
      console.debug(`find idx:${idx}`);
      if (idx >= 0) {
        fi.JDG_NO = items[idx].JDG_NO;
        items[idx] = fi;
        let autoValue = SetJusgeAutoSetting(items[idx], judgeAutoSettings.current, props.plcCollectSetting);
        if (autoValue.ALM_LIM !== null && autoValue.WRN_LIM !== null) {
          items[idx].ALM_LIM = autoValue.ALM_LIM;
          items[idx].WRN_LIM = autoValue.WRN_LIM;
        }
        setFlgUpdate(true);
      }
    });

    setItems([...items]);
  };

  /**
   * エラーレスポンス メッセージ変換
   * @param errCode
   * @param data
   * @returns
   */
  const ConvErrorMessage = (errCode: number, data: JudgeSettingErrorData) => {
    console.debug(`ConvErrorMessage() ${errCode}, ${data}`);
    switch (errCode) {
      case ErrorCode.ERR_CODE_JSET_JDG_TYP_REQUIRED_ITEMS:
        //診断タイプ:必須項目
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.診断タイプ', '診断タイプ')}:${t(
          'JudgeSettingDialog.必須項目',
          '必須項目'
        )}`;
      case ErrorCode.ERR_CODE_JSET_FREQ_C_INVALID_VALUE:
        //周波数：不正値
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.周波数', '周波数')}:${t(
          'JudgeSettingDialog.不正値',
          '不正値'
        )}`;
      case ErrorCode.ERR_CODE_JSET_FREQ_C_CANNOT_BE_SET:
        //周波数：設定不可
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.周波数', '周波数')}:${t(
          'JudgeSettingDialog.設定不可',
          '設定不可'
        )}`;
      case ErrorCode.ERR_CODE_JSET_FREQ_C_20TO6000:
        //周波数：20～6000
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.周波数', '周波数')}:${data.Min}～${data.Max}`;
      case ErrorCode.ERR_CODE_JSET_FREQ_C_1TO6000:
        //周波数：1～6000
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.周波数', '周波数')}:${data.Min}～${data.Max}`;
      case ErrorCode.ERR_CODE_JSET_CLC_TYP_REQUIRED_ITEMS:
        //演算方法：必須項目
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.演算方法', '演算方法')}:${t(
          'JudgeSettingDialog.必須項目',
          '必須項目'
        )}`;
      case ErrorCode.ERR_CODE_JSET_CLC_TYP_CANNOT_BE_SET:
        //演算方法：入力範囲エラー
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.演算方法', '演算方法')}:${t(
          'JudgeSettingDialog.入力範囲エラー',
          '入力範囲エラー'
        )}`;
      case ErrorCode.ERR_CODE_JSET_TWRN_LIM_INVALIDVALUE:
        //閾値_軽故障：不正値
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.閾値_軽故障', '閾値_軽故障')}:${t(
          'JudgeSettingDialog.不正値',
          '不正値'
        )}`;
      case ErrorCode.ERR_CODE_JSET_TWRN_LIM_0TO10000:
        //閾値_軽故障：0～10000
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.閾値_軽故障', '閾値_軽故障')}:${data.Min}～${data.Max
          }`;
      case ErrorCode.ERR_CODE_JSET_ALM_LIM_INVALID_VALUE:
        //閾値_重故障：不正値
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.閾値_重故障', '閾値_重故障')}:${t(
          'JudgeSettingDialog.不正値',
          '不正値'
        )}`;
      case ErrorCode.ERR_CODE_JSET_ALM_LIM_0TO10000:
        //閾値_重故障：0～10000
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.閾値_重故障', '閾値_重故障')}:${data.Min}～${data.Max
          }`;
      case ErrorCode.ERR_CODE_JSET_BAND_VAL_INVALID_VALUE:
        //裕度(%)：不正値
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.裕度', '裕度')}}:${t(
          'JudgeSettingDialog.不正値',
          '不正値'
        )}`;
      case ErrorCode.ERR_CODE_JSET_BAND_VAL_CANNOT_BE_SET:
        //裕度(%)：設定不可
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.裕度', '裕度')}:${t(
          'JudgeSettingDialog.設定不可',
          '設定不可'
        )}`;
      case ErrorCode.ERR_CODE_JSET_BAND_VAL_0TO10:
        //裕度(%)：0～10
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.裕度', '裕度')}:${data.Min}～${data.Max}`;
      case ErrorCode.ERR_CODE_JSET_ADJ_ROT_ON_INCORRECT_VALUE:
        //補正：回転数：不正値
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.補正：回転数', '補正：回転数')}:${t(
          'JudgeSettingDialog.不正値',
          '不正値'
        )}`;
      case ErrorCode.ERR_CODE_JSET_ADJ_ROT_ON_CANNOT_BE_SET:
        //補正：回転数：設定不可
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.補正：回転数', '補正：回転数')}:${t(
          'JudgeSettingDialog.設定不可',
          '設定不可'
        )}`;
      case ErrorCode.ERR_CODE_JSET_ALM_TYP_NO_REQUIRED_ITEM:
        //異常種別:必須項目
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.異常種別', '異常種別')}:${t(
          'JudgeSettingDialog.必須項目',
          '必須項目'
        )}`;
      case ErrorCode.ERR_CODE_JSET_ALM_TYP_NO_CANNOT_BE_SET:
        //異常種別：設定不可
        return `No:${data.ErrorItem.JDG_NO} ${t('JudgeSettingDialog.異常種別', '異常種別')}:${t(
          'JudgeSettingDialog.設定不可',
          '設定不可'
        )}`;
      default:
        return t('JudgeSettingDialog.システムエラーが発生しました', 'システムエラーが発生しました');
    }
  };

  const confirm = flgConfirm ? (
    <ConfirmDialog
      dialog={confirmDlg}
      message={msgConfirm}
      action={t('JudgeSettingDialog.はい', 'はい')}
      cancel={t('JudgeSettingDialog.いいえ', 'いいえ')}
    />
  ) : null;

  console.debug(['- 画面描画開始 -', items]);
  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        //fullWidth={true}
        //contentStyle={{ width: '600px' }}
        maxWidth="xl"
        onEntered={(e) => { }}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle>{t('JudgeSettingDialog.判定値設定', '判定値設定')}</DialogTitle>
        <DialogContent>
          {login.IsIoT ? null : (
            <span>
              PLC:{props.plcNo} {t('JudgeSettingDialog.- AIカード', '- AIカード')}:{props.aiCard} - CH:{props.aiCh}
            </span>
          )}
          <TableContainer className={judgeSettingStyle.tableContainer}>
            <Table aria-label="judgeSetting" stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell} width={10}>
                    No
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={20}>
                    {t('JudgeSettingDialog.使用', '使用')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('JudgeSettingDialog.演算種別', '演算種別')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('JudgeSettingDialog.診断タイプ', '診断タイプ')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={60}>
                    {t('JudgeSettingDialog.周波数', '周波数')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={30}>
                    {t('JudgeSettingDialog.裕度', '裕度')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('JudgeSettingDialog.演算方法', '演算方法')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={50}>
                    {t('JudgeSettingDialog.軽故障', '軽故障')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={50}>
                    {t('JudgeSettingDialog.重故障', '重故障')}
                  </TableCell>
                  {/* <TableCell className={tableBaseStyle.headerCell}>{t('JudgeSettingDialog.補正', '補正')}</TableCell> */}
                  <TableCell className={tableBaseStyle.headerCell} width={60}>
                    {t('JudgeSettingDialog.高調波判定', '高調波判定')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={90}>
                    {t('JudgeSettingDialog.2f\nキャンセル', '2f\nキャンセル')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('JudgeSettingDialog.異常種別', '異常種別')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item) => {
                  return (
                    <JudgeSettingItemRow
                      plcCollectSetting={props.plcCollectSetting}
                      judgeSettingItem={item}
                      judgeAutoSettings={judgeAutoSettings.current}
                      judgeItemSelectInfo={GetJudgeSelectItemInfo(judgeItemSelectInfo.current, props.plcCollectSetting)}
                      onChangeData={updateItem}
                      mclcTypeCombos={mclcTypeCombos}
                      jdgCombos={jdgCombos}
                      clcCombos={clcCombos}
                      almCombos={almCombos}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          {/* <input type="checkbox" onChange={(e) => changeDispMaskOn()} checked={dispMaskOn === 0 ? false : true} />
          {t('JudgeSettingDialog.速度_変位判定マスク', '変位（前日値）比較')} */}
          <Button
            className={judgeSettingStyle.buttonStyle}
            color="primary"
            variant="contained"
            disabled={!isBearingFeaturesFreqButton}
            onClick={(e) => {
              BearingFeaturesFreqButtonAction();
            }}
          >
            {t('JudgeSettingDialog.軸受特徴周波数自動設定', '軸受特徴周波数自動設定')}
          </Button>
          <Button
            className={judgeSettingStyle.buttonStyle}
            color="primary"
            variant="contained"
            disabled={!isSideBandFreqItemButton}
            onClick={(e) => {
              //console.debug(['- flgUpdate -', flgUpdate]);
              let regedIdx = items.findIndex(
                (row) => row.CHANGE_INVALID === 1 && row.JDG_TYP == 4 && (row.MCLC_TYP_ID == 9 || row.MCLC_TYP_ID == 10)
              );
              if (regedIdx === -1) {
                //初回追加の場合
                handleSideBandFreq();
              } else {
                if (flgUpdate) {
                  setMsgConfirm(t('JudgeSettingDialog.設定を更新しますか?', '設定を更新しますか?'));
                  confirmDlg
                    .open()
                    .apply((_) => {
                      handleSideBandFreq();
                    })
                    .cancel((_) => { });
                }
              }
            }}
          >
            {t('JudgeSettingDialog.側帯波周波数自動設定', '側帯波周波数自動設定')}
          </Button>

          <Button
            className={judgeSettingStyle.buttonStyle}
            color="primary"
            variant="contained"
            onClick={(e) => {
              console.debug(['- flgUpdate -', flgUpdate]);
              if (flgUpdate) {
                setMsgConfirm(t('JudgeSettingDialog.設定を保存しますか?', '設定を保存しますか?'));
                confirmDlg
                  .open()
                  .apply((resp) => {
                    // 保存処理
                    SetJudgeSettingItems(items).then((resp: JudgeSettingItemModel) => {
                      console.debug(['resp', resp]);
                      if (resp.ResponceData.ErrorCode == ErrorCode.ERR_CODE_NONE) {
                        //COL_SETのため、更新は上位に任せる
                        props.onChangeDspMskOn(dispMaskOn);
                        setIsOpen(false);
                        setMode(true);
                        return;
                      } else {
                        // エラーハンドリング
                        setShowTitle(t('JudgeSettingDialog.設定エラー', '設定エラー'));
                        setShowMessage(ConvErrorMessage(resp.ResponceData.ErrorCode, resp.JdgSetErrData));
                        setMessageDialogOpen(true);
                      }
                    });
                  })
                  .cancel((_) => { });
              } else {
                setIsOpen(false);
                setMode(false);
              }
            }}
          >
            {t('JudgeSettingDialog.設定', '設定')}
          </Button>
          <Button
            className={judgeSettingStyle.buttonStyle}
            style={{ marginRight: '30px' }}
            color="primary"
            variant="contained"
            onClick={(e) => {
              if (flgUpdate) {
                setMsgConfirm(
                  t(
                    'JudgeSettingDialog.保存していないデータを破棄します。\nよろしいですか?',
                    '保存していないデータを破棄します。\nよろしいですか?'
                  )
                );
                confirmDlg
                  .open()
                  .apply((resp) => {
                    setIsOpen(false);
                    setMode(true);
                  })
                  .cancel((_) => { });
              } else {
                setIsOpen(false);
                setMode(false);
              }
            }}
          >
            {t('JudgeSettingDialog.キャンセル', 'キャンセル')}
          </Button>
        </DialogActions>
      </Dialog>
      {confirm}
      <SimpleDialog
        open={messageDialogOpen}
        onClose={() => setMessageDialogOpen(false)}
        title={showTitle}
        okText={'OK'}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
    </>
  );
};

export default JudgeSettingDialog;
